
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Crown } from "lucide-react";
import { SubscriptionSection } from "@/components/plans/SubscriptionSection";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

export default function Plan() {
  const { getPath } = useLanguagePath();
  const { t } = useTranslations("dashboard");
  // Adicionar o hook para traduções de landing
  const { t: landingT } = useTranslations("landing");
  
  return (
    <div className="container py-6 space-y-6 max-w-5xl">
      <div className="space-y-1">
        <h2 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <Crown className="h-7 w-7 text-flame" />
          {t("plan.title")}
        </h2>
        <p className="text-muted-foreground">
          {t("plan.subtitle")}
        </p>
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={getPath("/dashboard")}>Dashboard</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{t("plan.title")}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      <SubscriptionSection />
    </div>
  );
}
